import React from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import randomMC from "random-material-color";

import { setRef, withStyles } from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Button from "@material-ui/core/Button";

import InstructorTopBar from "./InstructorTopBar";
import InstructorMenu from "./InstructorMenu";
import InstructorSessions from "./InstructorSessions";
import InstructorPolls from "./InstructorPolls";
import InstructorHoverPoll from "./InstructorHoverPoll";
import InstructorArchiveDialog from "./InstructorArchiveDialog";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { IconButton } from "@material-ui/core";

import {
  updatePollScreenshot,
  listenPoll,
  fetchCourses,
  fetchPolls,
  fetchSessions,
  createSession,
  createPoll,
  activateSession,
  activatePoll,
  deactivateSession,
  deactivatePoll,
  resumeSession,
  listenCourseActivity,
  listenPollStudents,
  displayPoll,
  displayInactivePoll,
  deleteSession,
  deletePoll,
  fetchPollStudents,
  setPollAnswer,
  getScreenshotURLs,
  fetchPoll,
  resumePoll,
  getCoInstructorCourses,
  getGeo,
  initGoogleApi,
  requestGoogleDriveAccess,
  uploadFileToFolder,
  getFileFromFolder,
  deleteFileFromFolder,
  setOverrideLive,
  mergeSession,
  setPollLock,
  validRefreshToken,
} from "../firebaseApi";
import { changeCourses, changePolls, changeSessions } from "../redux";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

const styles = (theme) => {};

function Instructor(props) {
  const [userMenuOpen, setUserMenuOpen] = React.useState(true);
  const [sessionMenuOpen, setSessionMenuOpen] = React.useState(true);
  const [activeSession, setActiveSession] = React.useState(null);
  const [activePoll, setActivePoll] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [coInstructorCourses, setCoInstructorCourses] = React.useState(null);

  const [showControls, setShowControls] = React.useState(false);
  const [poll, setPoll] = React.useState(null);
  const [persistentCategory, setPersistentCategory] = React.useState(null);
  const [persistentOptions, setPersistentOptions] = React.useState(null);

  const [globalCategory, setGlobalCategory] = React.useState(null);
  const [globalOptions, setGlobalOptions] = React.useState([]);
  const [instructorLocation, setInstructorLocation] = React.useState(null);
  const [loadingLocation, setLoadingLocation] = React.useState(false);
  const [showNoAccessDialog, setShowNoAccessDialog] = React.useState(false);
  const [sessionLoading, setSessionLoading] = React.useState(false);
  const [screenShareStream, setScreenShareStream] = React.useState(null);
  const [screenshotRender, setScreenshotRender] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [screenshotEnabledDevice, setScreenshotEnabledDevice] =
    React.useState(false);
  const [manualSessionStart, setManualSessionStart] = React.useState(false);
  const [geoInactiveCreateOrigin, setGeoInactiveCreateOrigin] =
    React.useState(true);
  const [broswerSettingsDialog, setBrowserSettingsDialog] =
    React.useState(false);
  const [driveInit, setDriveInit] = React.useState(false);
  const [openNoDeviceDialog, setNoDeviceDialog] = React.useState(false);
  const [openNoAccessDialog, setNoAccessDialog] = React.useState(false);
  const [markedArchiveCourses, setMarkedArchiveCourses] = React.useState([]);
  const [archivedCourses, setArchivedCourses] = React.useState([]);
  const [openArchiveDialog, setOpenArchiveDialog] = React.useState(false);
  const [initNotifyArchive, setInitNotifyArchive] = React.useState(false);

  let urlParams = props.match.params;
  let { courses, sessions, polls } = props;

  const handleGeolocation = async (origin) => {
    setLoadingLocation(true);

    try {
      if ("geolocation" in navigator) {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position),
            (error) => reject(error)
          );
        });

        const instructorLatitude = position.coords.latitude;
        const instructorLongitude = position.coords.longitude;
        setInstructorLocation({ instructorLatitude, instructorLongitude });

        return { instructorLatitude, instructorLongitude };
      } else {
        //console.log("Geolocation not available");
        setGeoInactiveCreateOrigin(origin);
        setShowNoAccessDialog(true);
      }
    } catch (error) {
      //console.error(error);
      setGeoInactiveCreateOrigin(origin);
      setShowNoAccessDialog(true);
    } finally {
      setLoadingLocation(false);
    }
  };

  const handleEndGeolocation = () => {
    setInstructorLocation(null);
  };

  const handleControls = () => {
    setShowControls(!showControls);
    if (!courses[urlParams.courseID].courseActivitySessionID && !showControls) {
      newSession(urlParams.courseID);
    } else if (
      courses[urlParams.courseID].courseActivitySessionID &&
      showControls
    ) {
      stopSession(urlParams.courseID);
    }
  };

  // React.useEffect(() => {
  //   setActivePoll(null);
  //   setActiveSession(null);
  // }, [props.selRole]);

  React.useEffect(() => {

    if (props.selRole === "instructor" && (!courses || Object.keys(courses).length === 0 || initNotifyArchive)) {
      return;
    } else if (props.selRole === "ta") {
      setInitNotifyArchive(true);
      return;
    }

    let notifyCourses = [];
    let archivedCourses = [];
    let display = false;

    for (const [id, data] of Object.entries(courses)) {

      if (data.notifyArchive) {
        display = true;
        const course = {
          id: id,
          name: data.courseName,
          term: data.courseTerm,
        };

        if (data.isActive) {
          notifyCourses.push(course);
        } else {
          archivedCourses.push(course);
        }
      }
    }
    setMarkedArchiveCourses(notifyCourses);
    setArchivedCourses(archivedCourses);
    setOpenArchiveDialog(display);
    setInitNotifyArchive(true);
  }, [courses, initNotifyArchive]);

  React.useEffect(() => {
    let data = { accountID: props.account.accountID };
    getCoInstructorCourses(data)
      .then((coInstructorCourses) => {
        // console.log("coInstructorCourses:", coInstructorCourses);
        setCoInstructorCourses(coInstructorCourses);
      })
      .catch((error) => {
        //console.error("Error fetching co-instructor courses:", error);
      });
  }, [props.courses]);

  React.useEffect(() => {
    let data = { accountID: props.account.accountID, selRole: props.selRole };
    fetchCourses(data).then((courses) => {
      props.changeCourses(courses);
    });
  }, [props.selRole]);

  // Check to see if screenshot enabled and screenshot device on render
  React.useEffect(() => {
    if (urlParams.courseID) {
      // CoInstuctor does not have screenshot permissions
      // try{
      //   if (urlParams.courseID in coInstructorCourses) {
      //     return;
      //   }
      // }catch(e){
      //   console.log(e)
      // }
      checkScreenshotPermissions();
    }
  }, [urlParams.courseID]);

  // React.useEffect(() => {
  //   console.log("HEREEEE");
  //   console.log(urlParams);
  //   // if (urlParams.sessionID)
  //   startScreenShare();
  // },[screenshotEnabledDevice]);

  // Check screenshot enabled and if this device is screenshot enabled device
  const canDeleteScreenshots = (courseInfo) => {
    return props.account.accountEmail == courseInfo?.courseInstructorID ||  
      courseInfo.coInstructors?.includes(props.account.accountEmail) || 
      ((courseInfo.taPrivileges?.includes("Take Screenshots if Feature Enabled") || 
      courseInfo.taPrivileges?.includes("Delete Polls")) && 
      courseInfo.tas?.includes(props.account.accountEmail));
  };

  const canTakeScreenshots = (courseID) => {
    if (courseID === undefined || courseID === null) return false;
    let courseInfo = props.courses[courseID] ?? coInstructorCourses[courseID];

    if (courseInfo === undefined) return false;

    return props.account.accountEmail == courseInfo.courseInstructorID ||  
      (courseInfo.coInstructors.includes(props.account.accountEmail) &&
      courseInfo.coInstructorEnableScreenshots) || 
      (courseInfo.taPrivileges.includes("Take Screenshots if Feature Enabled") && 
      courseInfo.tas.includes(props.account.accountEmail));
  };

  const checkScreenshotPermissions = () => {
    let courseInfo = props.courses[urlParams.courseID] ?? (coInstructorCourses[urlParams.courseID] ?? {});
    
    if (courseInfo?.screenshotsEn && canDeleteScreenshots(courseInfo)) {
      //need to add check to see if they can access screenshots
     
      let data = {
        courseID: urlParams.courseID,
        user: props.account.accountEmail,
      }
      initGoogleDrive(data);
      const deviceUUID = localStorage.getItem("deviceUUID");

      if (courseInfo?.screenshotDevice[props.account.accountEmail] === undefined || courseInfo?.screenshotDevice[props.account.accountEmail] === "") {
        setNoDeviceDialog(true);
      } else if (deviceUUID != null && courseInfo?.screenshotDevice[props.account.accountEmail] == deviceUUID) {
        setScreenshotEnabledDevice(true);
      }
    }
  };

  // Initialize google api and access google drive
  const initGoogleDrive = async (data) => {
    
    try {
      await initGoogleApi();
      await requestGoogleDriveAccess(data);
      const validToken = await validRefreshToken();

      if (!validToken) {
        setNoAccessDialog(true);
        setDriveInit(false);
      } else if (canTakeScreenshots(data.courseID)) {
        setDriveInit(true);
      }
    } catch (error) {
      console.error("Initialization Error:", error);
      setNoAccessDialog(true);
      setDriveInit(false);
    }
  };

  // Take screenshot on enabled device when poll is started on a seperate device
  React.useEffect(() => {
    
    if (driveInit && courses[urlParams.courseID]?.courseActivityPollLive) {
      takeScreenshot(courses[urlParams.courseID].courseActivityPollID);
    }
  }, [courses[urlParams.courseID]?.courseActivityPollLive, driveInit]);

  React.useEffect(() => {
    if (!courses[urlParams.courseID]?.courseActivityPollID) return;

    let pollID = courses[urlParams.courseID].courseActivityPollID;
    let data = {pollID: pollID};
    let unsubPoll = listenPoll(data, (updatedPoll) => {
      
      if (updatedPoll["pollSessionID"] !== undefined) {
        fetchPollStudents(data).then((students) => {
          updatedPoll.students = students;
          let newPolls = {...polls};
          newPolls[pollID] = updatedPoll;
          props.changePolls(newPolls);
        });
      }
    });
    return () => {unsubPoll();};
  }, [courses[urlParams.courseID]?.courseActivityPollID]);

  React.useEffect(() => {
    if (urlParams.courseID) {
      setLoading(true);
      let data = { courseID: urlParams.courseID };
      let unsubPoll = () => {};
      
      let unsub = listenCourseActivity(data, (updatedCourse) => {
        let newCourses = Object.assign({}, courses);
        newCourses[urlParams.courseID] = updatedCourse;

        let pollID = updatedCourse?.courseActivityPollID;
        if (pollID) {
          fetchPoll({ pollID: pollID }).then((fetchedPoll) => {
            setPoll(fetchedPoll);
          });
        }

        data = { courseID: updatedCourse.courseID };
        fetchSessions(data).then((sessions) => {
          data = { sessionID: updatedCourse.courseActivitySessionID };
          fetchPolls(data).then((polls) => {
            let pollsWithStudents = Object.assign({}, polls);
            let studentPromises = [];
            Object.keys(pollsWithStudents).forEach((key) => {
              let promise = fetchPollStudents({
                pollID: pollsWithStudents[key].pollID,
              });
              studentPromises.push(promise);
            });

            Promise.all(studentPromises).then((results) => {
              let keys = Object.keys(pollsWithStudents);
              results.forEach((students, i) => {
                pollsWithStudents[keys[i]].students = students;
              });

              setActiveSession(
                updatedCourse.courseActivitySessionID
                  ? sessions[updatedCourse.courseActivitySessionID]
                  : null
              );
              setActivePoll(
                updatedCourse.courseActivityPollID
                  ? pollsWithStudents[updatedCourse.courseActivityPollID]
                  : null
              );
              props.changePolls(pollsWithStudents);
              props.changeSessions(sessions);
              props.changeCourses(newCourses);

              if (updatedCourse.courseActivityPollLive) {
                let data = { pollID: updatedCourse.courseActivityPollID };
                unsubPoll = listenPollStudents(data, (students) => {
                  let newPolls = Object.assign({}, pollsWithStudents);
                  
                  newPolls[updatedCourse.courseActivityPollID].students =
                    students;
                  props.changePolls(newPolls);

                  let newPoll = Object.assign(
                    {},
                    newPolls[updatedCourse.courseActivityPollID]
                  );
                  setActivePoll(newPoll);
                });
              } else {
                unsubPoll();
                unsubPoll = () => {};
              }

              // setTimeout(async () => {
              //   if (updatedCourse.courseActivitySessionID) {
              //     let data = {
              //       accountEmail: props.account.accountEmail,
              //       sessionID: updatedCourse.courseActivitySessionID,
              //     };
              //     let urls = await getScreenshotURLs(data);

              //     Object.entries(polls).forEach(([pID, p]) => {
              //       p.screenshotURL = urls[pID];
              //     });

              //     props.changePolls(polls);
              //   }
              // }, 1500);

              let route = "/instructor/" + updatedCourse.courseID;
              route = updatedCourse.courseActivitySessionID
                ? route + "/" + updatedCourse.courseActivitySessionID
                : route;
              props.history.push(route);

              setLoading(false);
            });
          });
        });
      });

      return () => {
        props.changePolls({});
        props.changeSessions({});
        unsubPoll();
        unsub();
      };
    }
  }, [urlParams.courseID, rerender]);

  React.useEffect(() => {
    if (urlParams.sessionID) {
      setLoading(true);
      let data = {
        accountEmail: props.account.accountEmail,
        sessionID: urlParams.sessionID,
      };
      fetchPolls(data).then((polls) => {
        let pollsWithStudents = Object.assign({}, polls);
        let studentPromises = [];
        Object.keys(pollsWithStudents).forEach((key) => {
          let promise = fetchPollStudents({
            pollID: pollsWithStudents[key].pollID,
          });
          studentPromises.push(promise);
        });

        Promise.all(studentPromises).then((results) => {
          let keys = Object.keys(pollsWithStudents);
          results.forEach((students, i) => {
            pollsWithStudents[keys[i]].students = students;
          });

          props.changePolls(pollsWithStudents);

          setLoading(false);
        });
      });
    }
  }, [urlParams.sessionID]);

  async function newSession(courseID, geoInactive = false) {
    try {
      setSessionLoading(true);
      let data;

      const geoloc = await getGeo(courseID);
      if (geoloc && !geoInactive) {
        const { instructorLatitude, instructorLongitude } =
          await handleGeolocation(true);
        data = {
          sessionCourseID: courseID,
          sessionStartTime: Date.now(),
          instructorLatitude,
          instructorLongitude,
        };
      } else {
        data = {
          sessionCourseID: courseID,
          sessionStartTime: Date.now(),
        };
      }

      if (geoInactive) {
        data = { ...data, geoInactive: geoInactive };
      }

      return await createSession(data).then((sessionID) => {
        let data = { 
          sessionID: sessionID,
          totStudents: Object.keys(courses[courseID].students).length,
        };
        return activateSession(data);
      });
    } catch (error) {
      //console.error(error);
    } finally {

      // if (courses[courseID].screenshotsEn && !courses[courseID].screenshotDevice) {

      // } else if (courses[courseID].screenshotsEn && !courses[courseID].screenshotDevice) {
      //   setNoScreenshotDeviceDialog(true);
      // }
      setSessionLoading(false);
    }
  }

  function newPoll(sessionID, anonPoll,lockPoll) {
    let data = {
      pollSessionID: sessionID,
      pollStartTime: Date.now(),
      pollVotedColor: randomMC.getColor(),
      pollCategories: urlParams.courseID
        ? courses[urlParams.courseID].courseCategories
        : {},
      pollAnonymous: anonPoll,
      pollCreatedBy: props.account.accountEmail,
      lockedPoll:lockPoll,
    };
    return createPoll(data).then((pollID) => {
      let data = { pollID };
      return activatePoll(data);
    });
  }

  function stopSession(courseID) {
    // Turn off Geolocation Override Toggle
    if (courses[courseID].geofencing) {
      const overrideData = {
        sessionID: courses[courseID].courseActivitySessionID,
        status: false,
      };
      setOverrideLive(overrideData);
    }

    let data = { courseID };
    return deactivateSession(data);
  }

  function stopPoll(courseID) {
    let data = { courseID };
    return deactivatePoll(data);
  }

  async function resumeLastSession(courseID, geoInactive = false) {
    try {
      setSessionLoading(true);
      let data;

      const geoloc = await getGeo(courseID);
      if (geoloc && !geoInactive) {
        const { instructorLatitude, instructorLongitude } =
          await handleGeolocation(false);
        data = {
          courseID,
          instructorLatitude,
          instructorLongitude,
        };
      } else {
        data = {
          courseID,
        };
      }

      if (geoInactive) {
        data = { ...data, geoInactive: geoInactive };
      }

      return resumeSession(data);
    } catch (error) {
      //console.error(error);
    } finally {
      setSessionLoading(false);
    }
  }

  function setShowDisplay(showDisplay, courseID) {
    let data = {};
    if (activePoll != null) {
      data = { displayPoll: showDisplay, courseID, pollID: activePoll.pollID };
    } else {
      data = {
        displayPoll: showDisplay,
        courseID,
        pollID: Object.values(polls).reverse()[0].pollID,
      };
    }
    return displayPoll(data);
  }

  function setShowDisplayInactive(showDisplay, courseID, pollID) {
    let data = { displayPoll: showDisplay, courseID, pollID };

    // Exception for if the current poll is the poll being shown
    if (pollID == activePoll?.pollID) {
      return displayPoll(data);
    }
    return displayInactivePoll(data);
  }

  async function removeSession(sessionID) {
    let data = { sessionID };

    // Screenshot deletion
    if (courses[urlParams.courseID].screenshotsEn) {
      const pollsToDelete = await fetchPolls(data);
      Object.values(pollsToDelete).forEach((poll, index) => {
        //may need to init google drive anyways for this, maybe just ask curt what he prefers
        deleteScreenshot(poll.pollID);
      });
    }

    return deleteSession(data).then(() => {
      let newSessions = Object.assign({}, sessions);
      delete newSessions[sessionID];
      Object.values(newSessions).forEach((s, i) => {
        s.sessionIndex = i + 1;
      });
      props.changeSessions(newSessions);
    });
  }
  async function merge(courseID, sessionID,sessionNumber) {
    let data = {courseID:courseID, sessionID:sessionID,sessionNum:sessionNumber};
    return mergeSession(data).then(() => {
      let newSessions = Object.assign({}, sessions);
      delete newSessions[sessionID];
      Object.values(newSessions).forEach((s, i) => {
        s.sessionIndex = i + 1;
      });
      props.changeSessions(newSessions);
    });
  }

  function removePoll(pollID) {
    // Screenshot deletion
    if (courses[urlParams.courseID].screenshotsEn) {
      deleteScreenshot(pollID);
    }

    let data = { pollID };
    return deletePoll(data).then(() => {
      let newPolls = Object.assign({}, polls);
      delete newPolls[pollID];
      Object.values(newPolls).forEach((p, i) => {
        p.pollIndex = i + 1;
      });
      props.changePolls(newPolls);
    });
  }

  function setAnswer(pollID, answer) {
    let data = { pollID, answer };
    return setPollAnswer(data).then(() => {
      let newPolls = Object.assign({}, polls);
      newPolls[pollID].answer = answer;
      props.changePolls(newPolls);
    });
  }
  function setLock(pollID){
    let data = { pollID };
    return setPollLock(data).then(() => {
      let newPolls = Object.assign({}, polls);
      props.changePolls(newPolls);
    });
  }

  function restartPoll(pollID) {
    let data = { pollID };
    return resumePoll(data).then(() => {
      let newPolls = Object.assign({}, polls);
      newPolls[pollID].pollLive = true;
      props.changePolls(newPolls);
      setRerender(!rerender);
    });
  }

  async function startScreenShare() {
    if (!screenshotEnabledDevice || !courses[urlParams.courseID].screenshotsEn) {
      return;
    }
      
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          displaySurface: "monitor",
          logicalSurface: true,
        },
      });
      setScreenShareStream(stream);
    } catch (err) {
      console.error(`Error starting screen share: ${err}`);
    }
  }

  function stopScreenShare() {
    if (screenShareStream) {
      let tracks = screenShareStream.getTracks();
      tracks.forEach((track) => track.stop());
      setScreenShareStream(null);
    }
  }

  function dataURLToBlob(dataURL) {
    const [header, data] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(data);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: mime });
  }

  async function takeScreenshot(pollID) {

    if (!screenShareStream || !screenshotEnabledDevice || polls[pollID].pollCreatedBy != props.account.accountEmail) return;

    // Check to see if screenshot for this poll already exists (cases of refresh of screen will retrigger takeScreenshot)
    const fileName = `Webclicker-${pollID}.png`;
    const courseFolderID = courses[urlParams.courseID].googleDriveFolderID;
    const fileID = await getFileFromFolder(fileName, courseFolderID);
    console.log(fileID);
    if (fileID != null) return;

    try {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      let imageCapture = {};

      if ('ImageCapture' in window) { 
        const track = screenShareStream.getVideoTracks()[0];
        imageCapture = new ImageCapture(track);
      }

      if ('grabFrame' in imageCapture) {
        const bitmap = await imageCapture.grabFrame();
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
      } else {
        const video = document.createElement('video');
        // if ('srcObject' in video) {
        //   video.srcObject = screenShareStream;
        // } else {
        //   video.src = URL.createObjectURL(screenShareStream);
        // }
        
        await new Promise((resolve, reject) => {
          video.onloadedmetadata = () => {
            video.play();
            video.pause();
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            resolve();
          }
          video.srcObject = screenShareStream;
        })
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        // context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      }
      const dataURL = canvas.toDataURL();
      const blob = dataURLToBlob(dataURL);
      await uploadFileToFolder(blob, fileName, courseFolderID);
      await updatePollScreenshot({pollID: pollID});
      setScreenshotRender(!screenshotRender);
    } catch (err) {
      console.error(`Error: ${err}`);
    }
  }

  async function deleteScreenshot(pollID) {
    const fileName = `Webclicker-${pollID}.png`;
    const courseFolderID = courses[urlParams.courseID].googleDriveFolderID;
    const fileID = await getFileFromFolder(fileName, courseFolderID);
    if (fileID == null) return;

    deleteFileFromFolder(fileID);
  }

  return (
    <>
      {sessionLoading && <LinearProgress />}

      <div>
        <Dialog
          open={showNoAccessDialog}
          onClose={() => setShowNoAccessDialog(false)}
        >
          <DialogTitle>Location Access Denied!</DialogTitle>
          <DialogContent>
            <Typography>
              You've enabled Geofencing for this course, which uses your
              location at the start of the session to restrict voting access for
              students within a preset distance.
            </Typography>
            <div style={{ padding: "8px" }}></div>

            <Typography>
              However, you have not given permission for Webclicker to access
              your location. To use the Geofencing feature, reset these
              permissions through your device's browser settings.
              <IconButton
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  setBrowserSettingsDialog(true);
                }}
              >
                <InfoOutlinedIcon />
              </IconButton>
            </Typography>
            <div style={{ padding: "8px" }}></div>

            <Typography>
              If you do not have the opportunity to reset the permissions now,
              as a temporary fix, you can run the current session without
              Geofencing by clicking the button below.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setShowNoAccessDialog(false);
                if (geoInactiveCreateOrigin) {
                  newSession(urlParams.courseID, true);
                } else {
                  resumeLastSession(urlParams.courseID, true);
                }
              }}
              color="primary"
            >
              Disable Geolocation for Current Session
            </Button>
            <Button
              onClick={() => {
                setShowNoAccessDialog(false);
                setShowControls(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={broswerSettingsDialog}
          onClose={() => setBrowserSettingsDialog(false)}
        >
          <DialogTitle>Location Permission Instructions</DialogTitle>
          <DialogContent>
            <Typography>
              To reset your browser's location permissions for Webclicker,
              update it in settings. For example:
            </Typography>
            <div style={{ padding: "16px" }}></div>

            <Typography>
              In Chrome on PC: Settings –{">"} Privacy and security –{">"} Site
              settings –{">"} Permissions: Location –{">"} Look under Customized
              behaviors
            </Typography>
            <div style={{ padding: "8px" }}></div>

            <Typography>
              In Samsung Internet on mobile: Settings –{">"} Sites and downloads
              –{">"} Site permissions –{">"} Location
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setBrowserSettingsDialog(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <InstructorArchiveDialog
          markedArchiveCourses={markedArchiveCourses}
          archivedCourses={archivedCourses}
          open={openArchiveDialog}
          openCtl={(open) => {
            setOpenArchiveDialog(open);
          }}
        />
      </div>

      <Route
        path={["/instructor/:courseID?/:sessionID?", "/ta/:courseID?/:sessionID?"]}
        render={() => (
          <InstructorTopBar
            coInstructorCourses={coInstructorCourses}
            loading={loading}
            userMenuOpen={userMenuOpen}
            showControls={showControls}
            handleControls={handleControls}
            setShowControls={(show) => setShowControls(show)}
            loadingLocation={loadingLocation}
            setLoadingLocation={(loading) => setLoadingLocation(loading)}
            instructorLocation={instructorLocation}
            sessionLoading={sessionLoading}
            handleEndGeolocation={handleEndGeolocation}
            userMenuOpenCtl={(open) => {
              setUserMenuOpen(open);
            }}
            sessionMenuOpen={sessionMenuOpen}
            sessionMenuOpenCtl={(open) => {
              setSessionMenuOpen(open);
            }}
            course={courses[urlParams.courseID]}
            courseName={
              urlParams.courseID ? courses[urlParams.courseID]?.courseName : ""
            }
            newSession={() => newSession(urlParams.courseID)}
            newPoll={(anonPoll) => newPoll(activeSession.sessionID, anonPoll,false)}
            deactivateSession={() => stopSession(urlParams.courseID)}
            deactivatePoll={() => stopPoll(urlParams.courseID)}
            resumeSession={() => resumeLastSession(urlParams.courseID)}
            resumePoll={() => resumePoll(activePoll.pollID)}
            lastSessionAvailable={
              urlParams.courseID
                ? Boolean(
                    courses[urlParams.courseID]?.courseActivityLastSessionID
                  )
                : false
            }
            setShowDisplay={(show, poll) =>
              setShowDisplay(show, urlParams.courseID, poll)
            }
            sessionLive={
              urlParams.courseID
                ? Boolean(courses[urlParams.courseID]?.courseActivitySessionID)
                : false
            }
            pollShowDisplay={
              urlParams.courseID
                ? courses[urlParams.courseID]?.courseActivityPollDisplay
                : false
            }
            pollLive={
              activePoll
                ? courses[urlParams.courseID]?.courseActivityPollLive
                : false
            }
            pollNumber={
              activePoll
                ? activePoll.pollIndex
                : Object.keys(polls).length === 0
                ? 0
                : Object.values(polls).reverse()[0].pollIndex
            }
            pollStartTime={activePoll ? activePoll.pollStartTime : 0}
            pollAnonymous={activePoll ? activePoll.pollAnonymous : false}
            sessionNumber={activeSession ? activeSession.sessionIndex : 0}
            students={activePoll ? activePoll.students : []}
            startScreenShare={startScreenShare}
            stopScreenShare={stopScreenShare}
            setManualSessionStart={() => setManualSessionStart(true)}
          />
        )}
      />

      {showControls &&
        courses[urlParams.courseID].courseActivityPollDisplay == true && (
          <Route
            path={["/instructor/:courseID/:sessionID?", "/ta/:courseID/:sessionID?"]}
            render={() => (
              <Container maxWidth="md" align="center">
                <InstructorHoverPoll
                  poll={Object.values(polls).find(
                    (poll) =>
                      poll.pollID ===
                      courses[urlParams.courseID].courseActivityPollID
                  )}
                  pollsLength={Object.keys(polls).length}
                  polls={polls}
                  setShowDisplayInactive={(showDisplay, pollID) =>
                    setShowDisplayInactive(
                      showDisplay,
                      urlParams.courseID,
                      pollID
                    )
                  }
                  setAnswer={(pollID, answer) => setAnswer(pollID, answer)}
                />
              </Container>
            )}
          />
        )}

      {!showControls && (
        <>
          <Route
            path={["/instructor/:courseID?/:sessionID?", "/ta/:courseID?/:sessionID?"]}
            render={() => (
              <InstructorMenu
                open={userMenuOpen}
                coInstructorCourses={coInstructorCourses}
                handleControls={handleControls}
                showControls={showControls}
                openCtl={(open) => {
                  setUserMenuOpen(open);
                }}
                initGoogleDrive={async (data) => {
                  await initGoogleDrive(data)
                }}
                startScreenShare={startScreenShare}
                setRerender={() => setRerender(!rerender)}
                setScreenshotEnabledDevice={(boolean) =>
                  setScreenshotEnabledDevice(boolean)
                }
              />
            )}
          />

          <Route
            path={["/instructor/:courseID/:sessionID?", "/ta/:courseID/:sessionID?"]}
            render={() => (
              <InstructorSessions
                open={sessionMenuOpen}
                openNoDeviceDialog={openNoDeviceDialog}
                openNoDeviceDialogCtl={(open)=>{setNoDeviceDialog(open);}}
                openNoAccessDialog={openNoAccessDialog}
                openNoAccessDialogCtl={(open)=>{setNoAccessDialog(open);}}
                showControls={showControls}
                course={courses[urlParams.courseID]}
                coInstructorCourses={coInstructorCourses}
                handleControls={handleControls}
                openCtl={(open) => {
                  setSessionMenuOpen(open);
                }}
                sessions={sessions}
                urlParams={urlParams}
                deleteSession={(sessionID) => removeSession(sessionID)}
                mergeSesh = {(courseID, sessionID,sessionNum)=>{merge(courseID, sessionID,sessionNum)}}
                sessionActive={
                  urlParams.courseID
                    ? courses[urlParams.courseID]?.courseActivitySessionID
                    : ""
                }
              />
            )}
          />
          <Route
            path={["/instructor/:courseID/:sessionID/", "/ta/:courseID/:sessionID/"]}
            render={() => (
              <InstructorPolls
                userMenuOpen={userMenuOpen}
                coInstructorCourses={coInstructorCourses}
                userMenuOpenCtl={(open) => {
                  setUserMenuOpen(open);
                }}
                handleControls={handleControls}
                showControls={showControls}
                sessionMenuOpen={sessionMenuOpen}
                sessionMenuOpenCtl={(open) => {
                  setSessionMenuOpen(open);
                }}
                displayLive={
                  activePoll
                    ? courses[urlParams.courseID]?.courseActivityPollDisplay
                    : false
                }
                activePoll={
                  urlParams.courseID
                    ? courses[urlParams.courseID]?.courseActivityPollID
                    : ""
                }
                polls={polls}
                setLock = {setLock}
                setAnswer={setAnswer}
                deletePoll={(pollID) => removePoll(pollID)}
                resumePoll={(pollID) => restartPoll(pollID)}
                sessionActive={Boolean(activeSession)}
                setShowDisplayInactive={(show, pollID) =>
                  setShowDisplayInactive(show, urlParams.courseID, pollID)
                }
                screenshotRender={screenshotRender}
                screenshotEnabledDevice={screenshotEnabledDevice}
                course={courses[urlParams.courseID]}
                setRerender={() => setRerender(!rerender)}
                driveInit={driveInit}
              />
            )}
          />
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
    courses: state.courses,
    sessions: state.sessions,
    polls: state.polls,
    selRole: state.selRole,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCourses: (data) => dispatch(changeCourses(data)),
    changeSessions: (data) => dispatch(changeSessions(data)),
    changePolls: (data) => dispatch(changePolls(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(Instructor))));
